
























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { ResourceCategory as IResourceCategory } from "@/api/models/resource-category";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import webinars, { WebinarsListParams } from "@/getinfo-api/webinars";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";
import api from "@/getinfo-api";
import { uniqBy } from "lodash";
import WebinarListItemTable from "@/components/webinars/WebinarListItemTable.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CField,
    CPage,
    CustomButton,
    CustomTable,
    SelectEntity,
    WebinarListItemTable,
    CustomDatepicker,
    CustomTableItem,
    CustomTableCol
  }
})
export default class WebinarsList extends Vue {
  accessTokenProd!: any;
  accessTokenDev!: any;
  searchTitle!: string | undefined;
  categoryId!: string | undefined;
  categoryList!: IResourceCategory | undefined;
  status: "running" | "coming" | "finished" | undefined;
  ownerId!: string | undefined;
  startedAtMin!: Date | undefined;
  startedAtMax!: Date | undefined;
  priceMin!: number | undefined;
  priceMax!: number | undefined;
  limit: number = 30;
  offset: number = 0;
  webinars: Array<IWebinar> = [];
  webinarsCount!: number | undefined;
  companyWebinars: Array<IWebinar> = [];
  companyWebinarsCount!: number | undefined;
  employeeList!: IEmployeesList2 | undefined;
  showSpinner: boolean = false;
  enabled: boolean | undefined = true;
  showWebinar: boolean = false;
  showCompanyWebinar: boolean = false;
  locale: string | undefined = "";

  data() {
    return {
      accessTokenProd: null,
      accessTokenDev: null,
      searchTitle: undefined,
      categoryId: undefined,
      status: undefined,
      categoryList: undefined,
      ownerId: undefined,
      startedAtMin: undefined,
      startedAtMax: undefined,
      priceMin: undefined,
      priceMax: undefined,
      webinarsCount: undefined,
      companyWebinarsCount: undefined,
      employeeList: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get root() {
    return isRoot();
  }

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  applyFilter() {
    this.offset = 0;
    this.webinars = [];
    this.companyWebinars = [];
    this.companyWebinarsCount = undefined;
    this.webinarsCount = undefined;
    if (this.selectedCompanyId) {
      this.getWebinars(this.offset);
      this.getCompanyWebinars(this.offset);
    } else {
      this.getWebinars(this.offset);
    }
  }

  changeOffsetByWebinarsListMode(mode: "listener" | "employee") {
    const getOffset = (array: Array<IWebinar>) => {
      const length = array.length;

      return length < this.limit ? 0 : length - this.limit;
    };

    this.offset =
      mode === "listener"
        ? getOffset(this.webinars)
        : getOffset(this.companyWebinars);
  }

  showMore() {
    this.offset += this.limit;
    this.getWebinars(this.offset);
  }

  showMoreCompanyWebinars() {
    this.offset += this.limit;
    this.getCompanyWebinars(this.offset);
  }

  getWebinarsCategories() {
    if (this.selectedCompanyId) {
      api.WebinarApi.categories(undefined, this.selectedCompanyId).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    } else {
      api.WebinarApi.categories(this.userId, undefined).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    }
  }

  getCompanyWebinars(offset: number = 0) {
    this.showCompanyWebinar = false;
    if (this.root || this.companyOwner) {
      let params: WebinarsListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryId: this.categoryId ? this.categoryId : undefined,
        companyId: this.selectedCompanyId,
        ownerId: this.ownerId ? this.ownerId : undefined,
        priceMin: this.priceMin ? this.priceMin : undefined,
        startedAtMin: this.startedAtMin ? this.startedAtMin : undefined,
        startedAtMax: this.startedAtMax ? this.startedAtMax : undefined,
        priceMax: this.priceMax ? this.priceMax : undefined,
        status: this.status ? this.status : undefined,
        locale: this.locale ?? undefined,
        enabled: this.enabled,
        sort: "updatedAt",
        order: "DESC",
        limit: this.limit,
        offset: offset
      };

      webinars(params).then((res: { data: IWebinarList }) => {
        this.companyWebinarsCount = res.data.count;
        if (res.data.webinars.length === 0) this.showCompanyWebinar = true;
        this.companyWebinars = [...this.companyWebinars, ...res.data.webinars];
        this.companyWebinars = uniqBy(this.companyWebinars, "id");
      });
    } else {
      if (this.selectedCompanyId) {
        let params: WebinarsListParams = {
          title: this.searchTitle ? this.searchTitle : undefined,
          categoryId: this.categoryId ? this.categoryId : undefined,
          companyId: this.selectedCompanyId,
          ownerId: this.userId ? this.userId : undefined,
          priceMin: this.priceMin ? this.priceMin : undefined,
          priceMax: this.priceMax ? this.priceMax : undefined,
          status: this.status ? this.status : undefined,
          enabled: this.enabled,
          locale: this.locale ?? undefined,
          startedAtMin: this.startedAtMin ? this.startedAtMin : undefined,
          startedAtMax: this.startedAtMax ? this.startedAtMax : undefined,
          sort: "updatedAt",
          order: "DESC",
          limit: this.limit,
          offset: offset
        };

        webinars(params).then((res: { data: IWebinarList }) => {
          this.companyWebinarsCount = res.data.count;
          if (res.data.webinars.length === 0) this.showCompanyWebinar = true;
          this.companyWebinars = [
            ...this.companyWebinars,
            ...res.data.webinars
          ];
          this.companyWebinars = uniqBy(this.companyWebinars, "id");
        });
      }
    }
  }

  getWebinars(offset: number = 0) {
    this.showWebinar = false;
    this.showSpinner = true;

    if (this.root) {
      let params: WebinarsListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryId: this.categoryId ? this.categoryId : undefined,
        status: this.status ? this.status : undefined,
        ownerId: this.ownerId ? this.ownerId : undefined,
        priceMin: this.priceMin ? this.priceMin : undefined,
        priceMax: this.priceMax ? this.priceMax : undefined,
        startedAtMin: this.startedAtMin ? this.startedAtMin : undefined,
        startedAtMax: this.startedAtMax ? this.startedAtMax : undefined,
        locale: this.locale ?? undefined,
        sort: "updatedAt",
        order: "DESC",
        limit: this.limit,
        offset: offset
      };

      webinars(params)
        .then((res: { data: IWebinarList }) => {
          this.webinarsCount = res.data.count;
          if (res.data.webinars.length === 0) this.showWebinar = true;
          this.webinars = [...this.webinars, ...res.data.webinars];
          this.webinars = uniqBy(this.webinars, "id");
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      let paramsForListener: WebinarsListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        viewerId: this.userId,
        ownerId: this.ownerId ? this.ownerId : undefined,
        categoryId: this.categoryId ? this.categoryId : undefined,
        status: this.status ? this.status : undefined,
        startedAtMin: this.startedAtMin ? this.startedAtMin : undefined,
        startedAtMax: this.startedAtMax ? this.startedAtMax : undefined,
        priceMin: this.priceMin ? this.priceMin : undefined,
        priceMax: this.priceMax ? this.priceMax : undefined,
        locale: this.locale ?? undefined,
        sort: "updatedAt",
        enabled: true,
        order: "DESC",
        limit: this.limit,
        offset: offset
      };

      webinars(paramsForListener)
        .then((res: { data: IWebinarList }) => {
          this.webinarsCount = res.data.count;
          if (res.data.webinars.length === 0) this.showWebinar = true;
          this.webinars = [...this.webinars, ...res.data.webinars];
          this.webinars = uniqBy(this.webinars, "id");
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getAccessToken() {
    this.accessTokenDev = localStorage.getItem("auth-tokens-development");
    this.accessTokenProd = localStorage.getItem("auth-tokens-production");

    this.accessTokenProd
      ? (this.accessTokenProd = JSON.parse(this.accessTokenProd))
      : (this.accessTokenDev = JSON.parse(this.accessTokenDev));
  }

  getEmployees() {
    if (this.selectedCompanyId && (this.root || this.companyOwner)) {
      let params: EmployeeListParams = {
        id: this.selectedCompanyId,
        roles: ["content_manager"],
        limit: 200
      };

      employee(params).then((res: { data: IEmployeesList2 }) => {
        this.employeeList = res.data;
      });
    }
  }

  clear() {
    this.updateWebinars();
  }

  @Watch("selectedCompanyId")
  updateWebinars() {
    this.offset = 0;
    this.webinars = [];
    this.companyWebinars = [];
    this.companyWebinarsCount = undefined;
    this.webinarsCount = undefined;
    this.searchTitle = undefined;
    this.categoryId = undefined;
    this.priceMin = undefined;
    this.priceMax = undefined;
    this.startedAtMin = undefined;
    this.startedAtMax = undefined;
    this.employeeList = undefined;
    this.ownerId = undefined;
    this.status = undefined;
    this.locale = undefined;
    this.enabled =
      this.root || this.contentManager || this.companyOwner ? undefined : true;
    this.showSpinner = true;
    this.getEmployees();
    this.getWebinars();
    this.getCompanyWebinars();
    this.getWebinarsCategories();
  }

  mounted() {
    this.showSpinner = true;
    this.getAccessToken();
    this.getWebinars();
    if (this.selectedCompanyId) {
      this.getCompanyWebinars();
      this.getEmployees();
      this.getWebinarsCategories();
    }
  }
}
